export default {
  PreviousPolicyNumber: 'Previous Policy Number',
  NameOfInsuranceCompany: 'Name of Insurance Company',
  PreviousInsuranceCompany: 'Name Of Previous Insurance Company',
  PreviousPolicyRetroactiveDate: 'Retroactive date',
  PreviousPolicyExpirationDate: 'Previous Policy Expiration Date',
  RetroactiveDate: 'Retroactive date',
  RetroactiveDateDescription: 'The date mentioned in your previous policy',
  CheckIfDoNotKnowRetroactiveDate:
    'Check here if you do not know the retroactive date',
  GetQuotes: 'GET QUOTES',
  UninterruptedDurationAndEffectiveDateMessage:
    'Please enter the Uninterrupted duration and / or the effective date of the previous policy',
  UninterruptedRetroactiveDurationPlaceholder:
    'Uninterrupted Retroactive Duration (in months)',
  policyNumberRequired: 'Policy number is required',
  insuranceCompanyRequired: 'Insurance company is required',
  expirationDateRequired: 'Expiration date is required',
  retroactiveDateRequired: 'Retroactive date is required',
  previousPolicyDetailsRequired: 'Previous policy details are required',
  uninterruptedDurationMax: 'Retroactive period cannot exceed 240 months',
  PolicyEffectiveDatePlaceholder: 'Policy Effective Date',
  dateDifferenceValidation:
    'The difference between the effective and expiration date must be at least one calendar year.',
} as const
